
export class CustomDeviceConstants {

    // For device parameters, action IDs, etc

    public static DRYER_ACTION_EDIT_TARGET_IP: string = "edit_target_ip";

}
